export async function errorMessage(response, fallback) {
  try {
    const json = await response.json();
    if (json && json.message) return json.message;
  } catch (e) {
    
  }
  return fallback;
}
